import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="1" y="5" width="14" height="7" rx="1" stroke="white" strokeWidth="2" />
      <rect x="4" y="1" width="8" height="4" rx="1" stroke="white" strokeWidth="2" />
      <rect x="4" y="9" width="8" height="6" rx="1" fill="black" stroke="white" strokeWidth="2" />
    </svg>
  );
};

export default Svg;
